import { flat, flatMap, go, html, map, strMap } from 'fxjs/es';
import { MarketplaceS } from '../../../../../../Marketplace/S/Function/module/MarketplaceS.js';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessInboundS } from '../../../../../Inbound/S/Function/module/NessInboundS.js';
import { NessInboundTmplS } from '../../../../../Inbound/S/Tmpl/module/NessInboundTmplS.js';
import { NessAppEmptyScreenTmplS } from '../../../../EmptyScreen/S/Tmpl/module/NessAppEmptyScreenTmplS.js';
import { NessAppPlusHomeConstantS } from '../../../Home/S/Constant/module/NessAppPlusHomeConstantS.js';
import { NessProductListType } from '../Constant/product.js';
import { customCategiryListTmpl, customFilterCategoryListTmpl } from './customProduct.js';
import { makeNessLiveProductItemHtml } from './nessLiveProductItem.js';
import { customProductHeaderTmpl } from '../../../../../Core/S/Tmpl/custom.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';

const component = 'ness-plus-product-list';

/**
 * @param {{name: string, value: string}[]} sort_options
 * @param {{name: string, value: string}} selected_sort_option
 * @param cate_list_id
 * @param cate_item_id
 * @param cate_lists
 * @param products
 * @param plus_crew
 * @param is_mobile
 * @param {boolean} only_limited
 * @param {boolean} is_not_sold_out
 * @param {string} product_list_type
 * @param {object} custom_data
 * @param {boolean} is_custom_store
 * @param {string} domain_name
 * @param {string | null} custom_level
 * @returns {HTMLDivElement}
 */
export const makeProductList = (
  {
    sort_options,
    selected_sort_option,
    cate_list_id,
    cate_item_id,
    cate_lists,
    products,
    plus_crew = [],
    is_mobile,
    only_limited,
    is_not_sold_out,
    product_list_type,
    custom_data = {},
    custom_level = null,
  },
  is_custom_store,
  domain_name,
) => {
  const is_custom_category = product_list_type === NessProductListType.custom;
  const is_pc = !is_mobile;
  return html`
    <div
      class="${component}"
      data-type="${product_list_type}"
      data-domain_name="${domain_name}"
      data-is_asset_store="${is_custom_store}"
      data-custom_level="${custom_level}"
    >
      <div class="${component}__features">
        <div class="ness-plus-product-list__cate-lists__custom">
          ${UtilS.htmlIf(is_pc, customProductHeaderTmpl(is_mobile))}
          <div class="${component}__custom-category">
            ${is_custom_category
              ? html`${customFilterCategoryListTmpl(custom_data.custom_filter_menu_data, is_mobile)}
                ${customCategiryListTmpl(
                  custom_data.custom_product_cate_list,
                  custom_data.custom_filter_menu_data,
                  products,
                )}`
              : ``}
          </div>
        </div>
        <div class="${component}__cate-lists" data-is_asset="${is_custom_category}">
          ${categoryListTmpl(product_list_type, cate_lists, cate_list_id, is_custom_store)}
        </div>
        <div class="${component}__filters">
          ${filterTmpl(
            product_list_type,
            cate_lists,
            cate_list_id,
            cate_item_id,
            only_limited,
            is_not_sold_out,
            sort_options,
            selected_sort_option,
            is_mobile,
            is_custom_store,
          )}
        </div>
      </div>
      <div class="${component}__products-wrapper">
        <div class="${component}__products" data-show="${products.length > 0}">
          ${strMap((product) => nessProductLazyLoadTmpl(product, is_mobile), products)}
        </div>
        <div class="${component}__products--empty" data-show="${products.length === 0}">
          ${emptyProductListTmpl()}
        </div>
      </div>
    </div>
  `;
};

export const categoryListTmpl = (product_list_type, cate_lists, cate_list_id, is_custom_store) => {
  return html`
    ${is_custom_store
      ? html`<span
          class="${component}__cate-list"
          data-id="${NessProductListType.custom}"
          data-selected="${product_list_type == NessProductListType.custom}"
        >
          커스텀
        </span>`
      : ''}
    <span
      class="${component}__cate-list"
      data-id="${NessProductListType.recent}"
      data-selected="${product_list_type == NessProductListType.recent}"
    >
      ${ET('ness::product::product_04')}
    </span>
    <span
      class="${component}__cate-list"
      data-id="${NessProductListType.limit}"
      data-selected="${product_list_type == NessProductListType.limit}"
    >
      ${ET('ness::product::product_06')}
    </span>
    ${NessAppPlusHomeConstantS.isBestSellerShow
      ? html`
          <span
            class="${component}__cate-list"
            data-id="${NessProductListType.popular}"
            data-selected="${product_list_type == NessProductListType.popular}"
          >
            ${ET('ness::product::product_08')}
          </span>
        `
      : ''}
    ${strMap((cate_list) => {
      return html`<span
        class="${component}__cate-list"
        data-id="${cate_list.id}"
        data-selected="${cate_list_id == cate_list.id}"
      >
        ${cate_list.name}
      </span>`;
    }, cate_lists)}
  `;
};

export const filterTmpl = (
  product_list_type,
  cate_lists,
  cate_list_id,
  cate_item_id,
  only_limited,
  is_not_sold_out,
  sort_options,
  selected_sort_option,
  is_mobile,
  is_custom_store,
) => {
  // todo @ddevkim 커스텀 번역 적용
  return html`
    <div class="${component}__cate-items">
      ${is_custom_store
        ? html`<span
            class="${component}__cate-item"
            data-cate_list="${NessProductListType.custom}"
            data-show="${product_list_type == NessProductListType.custom}"
            data-selected="${product_list_type == NessProductListType.custom}"
          >
          </span>`
        : ''}
      <span
        class="${component}__cate-item"
        data-cate_list="${NessProductListType.recent}"
        data-show="${product_list_type == NessProductListType.recent}"
        data-selected="${product_list_type == NessProductListType.recent}"
      >
        ${ET('ness::product::product_03')}
      </span>
      <span
        class="${component}__cate-item"
        data-cate_list="${NessProductListType.limit}"
        data-show="${product_list_type == NessProductListType.limit}"
        data-selected="${product_list_type == NessProductListType.limit}"
      >
        ${ET('ness::product::product_05')}
      </span>
      <span
        class="${component}__cate-item"
        data-cate_list="${NessProductListType.popular}"
        data-show="${product_list_type == NessProductListType.popular}"
        data-selected="${product_list_type == NessProductListType.popular}"
      >
        ${ET('ness::product::product_07')}
      </span>
      ${go(
        cate_lists,
        flatMap((cate_list) => {
          const is_selected_list = cate_list_id == cate_list.id;

          return flat([
            html` <button
              class="${component}__cate-item"
              data-cate_list="${cate_list.id}"
              data-id="all"
              data-show="${is_selected_list}"
              data-selected="${is_selected_list && !cate_item_id}"
            >
              ${ET('common::all')}
            </button>`,
            map(
              (cate_item) =>
                html` <button
                  class="${component}__cate-item"
                  data-cate_list="${cate_list.id}"
                  data-id="${cate_item.id}"
                  data-show="${is_selected_list}"
                  data-selected="${cate_item_id == cate_item.id}"
                >
                  ${cate_item.name}
                </button>`,
              cate_list._.cate_items,
            ),
          ]);
        }),
        (xs) => xs.join(''),
      )}
    </div>
    <div class="${component}__product-filters">
      <span class="${component}__limited-filter">
        ${NessInboundTmplS.checkbox({
          name: 'only_limited',
          is_active: only_limited,
          title: ET('ness::product::only_limited', { context: is_mobile ? 'mo' : null }),
        })}
      </span>
      <span class="${component}__soldout-filter">
        ${NessInboundTmplS.checkbox({
          name: 'is_not_sold_out',
          is_active: is_not_sold_out,
          title: ET('ness::product::only_stock_available', { context: is_mobile ? 'mo' : null }),
        })}
      </span>
      <span class="${component}__sort-box" ${sort_options?.length ? '' : 'display: none'}>
        ${NessCoreTmplS.dropdown({
          selected_option: selected_sort_option,
          options: sort_options,
          klass: `${component}__dropdown`,
        })}
      </span>
    </div>
  `;
};

export const nessProductLazyLoadTmpl = (product, is_mobile, klass = '') => {
  return NessInboundS.productItem(
    flat(['v2', MarketplaceS.getMarketPlaceName()]),
    klass,
    true,
    is_mobile,
  )(product);
};

export const nessLiveProductTmpl = (product, live_title, is_mobile, klass) => {
  return makeNessLiveProductItemHtml(
    flat(['v2', MarketplaceS.getMarketPlaceName()]),
    klass,
    true,
    is_mobile,
  )(product, live_title);
};

export const nessProductNonLazyLoadTmpl = (product, is_mobile, klass = '') => {
  return NessInboundS.productItem(
    flat(['v2', MarketplaceS.getMarketPlaceName()]),
    klass,
    false,
    is_mobile,
  )(product);
};

export const emptyProductListTmpl = () => {
  return NessAppEmptyScreenTmplS.emptyTmpl({
    title: ET('ness::product::product_09'),
    description: ET('ness::product::product_10'),
  });
};
